import {
  registerByWechatMiniProgram,
  loginByWechatMiniProgram,
  getPhoneNumber,
  testTrans,
} from '@/api/wechatminiprogramaccountserv'

export default {
  state: {
    state_WechatMiniProgramAccount_RegisterByWechatMiniProgramResult: null,
    state_WechatMiniProgramAccount_LoginByWechatMiniProgramResult: null,
    state_WechatMiniProgramAccount_GetPhoneNumberResult: null,
    state_WechatMiniProgramAccount_TestTransResult: null,
  },
  mutations: {
    SET_WECHATMINIPROGRAMACCOUNT_REGISTERBYWECHATMINIPROGRAM_RESULT: (state, rst) => {
      state.state_WechatMiniProgramAccount_RegisterByWechatMiniProgramResult = rst;
    },
    SET_WECHATMINIPROGRAMACCOUNT_LOGINBYWECHATMINIPROGRAM_RESULT: (state, rst) => {
      state.state_WechatMiniProgramAccount_LoginByWechatMiniProgramResult = rst;
    },
    SET_WECHATMINIPROGRAMACCOUNT_GETPHONENUMBER_RESULT: (state, rst) => {
      state.state_WechatMiniProgramAccount_GetPhoneNumberResult = rst;
    },
    SET_WECHATMINIPROGRAMACCOUNT_TESTTRANS_RESULT: (state, rst) => {
      state.state_WechatMiniProgramAccount_TestTransResult = rst;
    },
  },
  actions: {
    WechatMiniProgramAccountServ_RegisterByWechatMiniProgram({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        registerByWechatMiniProgram(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WECHATMINIPROGRAMACCOUNT_REGISTERBYWECHATMINIPROGRAM_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WECHATMINIPROGRAMACCOUNT_REGISTERBYWECHATMINIPROGRAM_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WechatMiniProgramAccountServ_LoginByWechatMiniProgram({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        loginByWechatMiniProgram(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WECHATMINIPROGRAMACCOUNT_LOGINBYWECHATMINIPROGRAM_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WECHATMINIPROGRAMACCOUNT_LOGINBYWECHATMINIPROGRAM_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WechatMiniProgramAccountServ_GetPhoneNumber({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPhoneNumber(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WECHATMINIPROGRAMACCOUNT_GETPHONENUMBER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WECHATMINIPROGRAMACCOUNT_GETPHONENUMBER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WechatMiniProgramAccountServ_TestTrans({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        testTrans(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WECHATMINIPROGRAMACCOUNT_TESTTRANS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WECHATMINIPROGRAMACCOUNT_TESTTRANS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_WechatMiniProgramAccount_RegisterByWechatMiniProgramResult: state => {
      return state.state_WechatMiniProgramAccount_RegisterByWechatMiniProgramResult;
    },
    get_WechatMiniProgramAccount_LoginByWechatMiniProgramResult: state => {
      return state.state_WechatMiniProgramAccount_LoginByWechatMiniProgramResult;
    },
    get_WechatMiniProgramAccount_GetPhoneNumberResult: state => {
      return state.state_WechatMiniProgramAccount_GetPhoneNumberResult;
    },
    get_WechatMiniProgramAccount_TestTransResult: state => {
      return state.state_WechatMiniProgramAccount_TestTransResult;
    },
  }
}